import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ledgerDate } from '../../interface/ledger/ledger';
import { Seller } from '../../interface/seller/seller';
import { HttpService } from '../http/http.service';
import { toDateParam } from 'src/app/utils';

@Injectable({
  providedIn: 'root'
})
export class SellerService {

  constructor(private _httpService: HttpService) { }

  getAll(): Promise<Seller[]> {
    return firstValueFrom(this._httpService.get('/Sellers'));
  }
  get(id: number): Promise<Seller> {
    return firstValueFrom(this._httpService.get('/Sellers/' + id));
  }

  public async create(data: Seller): Promise<Seller> {
    return firstValueFrom(this._httpService.post('/Sellers', data))
  }
  public async update(id: number, data: Seller): Promise<Seller> {
    return firstValueFrom(this._httpService.patch('/Sellers/', id, data));
  }
  public async delete(id: number): Promise<void> {
    return firstValueFrom(this._httpService.delete('/Sellers/', id));
  }
  public async getledger(id: number, data: ledgerDate):Promise<any> {
    if (data.startDate == null && data.endDate == null) {
      return await firstValueFrom(this._httpService.get('/Sellers/' + id + '/ledger'))

    } else {
      return await firstValueFrom(this._httpService.get('/Sellers/' + id + '/ledger?startDate=' + toDateParam(data.startDate) + '&endDate=' + toDateParam(data.endDate)))
    }
  }
  getinvoice(id: number, data: ledgerDate) {
    if (data.startDate == null && data.endDate == null) {
      return this._httpService.get('/Sellers/' + id + '/invoices')

    } else {
      return this._httpService.get('/Sellers/' + id + '/invoices?startDate=' + toDateParam(data.startDate) + '&endDate=' + toDateParam(data.endDate))
    }
  }
}
